import Head from 'next/head';
import Layout from '../../../components/layout';
import style from '../../../styles/pages/experiencias/experienciaNuevas.module.scss';
import Paragraph from '../../../components/experiencias/paragraph';
import Card from '../../../components/experiencias/card';
import { useTranslations } from 'next-intl';
import OffersCards from '../../../components/experiencias/offersCards';

const pathIcon = '/images/experiencias/icons/';
const pathbackground = '/images/experiencias/TopcardTN.svg';

export default function CuerposDeAgua() {
  const t = useTranslations('Experiencias.travesiaNatural.cuerposAgua');
  const qualification = t('title');
  const image = '/images/experiencias/CuerposDeAgua.jpg';
  const paragraph = t('paragraph');
  const secondTitle = t('secondTitle');
  const description = t('description');
  const cards = [
    {
      tittel: 'Timbío',
      image: pathbackground,
      contents: [
        {
          description: t('Timbío.trekkingChorrera'),
          logo: pathIcon + 'Adventure.svg',
        },
      ],
    },
    {
      tittel: 'Sandoná',
      image: pathbackground,
      contents: [
        {
          description: t('Sandoná.visitaCaídasAguas'),
          logo: pathIcon + 'Mountains and Volcanoes.svg',
        },
      ],
    },
    {
      tittel: 'Cajibío',
      image: pathbackground,
      contents: [
        {
          description: t('Cajibío.visitaLago'),
          logo: pathIcon + 'Adventure.svg',
        },
      ],
    },
    {
      tittel: 'Acandí',
      image: pathbackground,
      contents: [
        {
          description: t('Acandí.senderismo'),
          logo: pathIcon + 'Adventure.svg',
        },
        {
          description: t('Acandí.ríosCascadas'),
          logo: pathIcon + 'Diving.svg',
        },
      ],
    },
    {
      tittel: 'Quibdó',
      image: pathbackground,
      contents: [
        {
          description: t('Quibdó.travesíasRío'),
          logo: pathIcon + 'Diving.svg',
        },
      ],
    },
    {
      tittel: 'Buenaventura',
      image: pathbackground,
      contents: [
        {
          description: t('Buenaventura.senderismo'),
          logo: pathIcon + 'Adventure.svg',
        },
        {
          description: t('Buenaventura.ríosCascadas'),
          logo: pathIcon + 'Diving.svg',
        },
      ],
    },
    {
      tittel: 'Jamundí',
      image: pathbackground,
      contents: [
        {
          description: t('Jamundí.senderismo'),
          logo: pathIcon + 'Adventure.svg',
        },
        {
          description: t('Jamundí.ríosCascadas'),
          logo: pathIcon + 'Diving.svg',
        },
      ],
    },
    {
      tittel: 'Patía',
      image: pathbackground,
      contents: [
        {
          description: t('Patía.tubingRío'),
          logo: pathIcon + 'tubing.svg',
        },
      ],
    },
  ];

  return (
    <>
      <Head>
        <title>{t('titleHead')}</title>
      </Head>

      <Layout>
        <div className={style.page}>
          <div className={style.titulo}>
            <h1>{qualification}</h1>
          </div>
          <div className={style.banner}>
            <img src={image} alt="Banner" />
          </div>
          <div className={style.contenido}>
            <Paragraph
              Paragraph={paragraph}
              description={description}
              secondTitle={secondTitle}
            />
            <div className={style.cards}>
              <h2>{t('actividadesPorHacer')}</h2>
              <div>
                {cards.map((card, index) => {
                  return (
                    <Card
                      key={index}
                      tittel={card.tittel}
                      image={card.image}
                      contents={card.contents}
                    />
                  );
                })}
              </div>
            </div>
            <div className={style.ofertas}>
              <OffersCards idTipoTurismo={4} />
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}

export async function getStaticProps({ locale }) {
  const response = await import(`../../../lang/${locale}.json`);

  return {
    props: {
      lang: response.default,
    },
  };
}
